import { Injectable } from "@angular/core";
import { Services, Assinatura } from "@smdapp/shared";
import { Store, Action, action } from "@smdlib/statex/@angular";
import { VisualizadorService } from "./visualizador-service";
import { AppState } from '@smdapp/flux/state/app.state';
import { DocumentoTramite } from "@smdapp/shared/models/documento-tramite";
import { saveAs } from 'file-saver';
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ErroApp } from '../../shared/models/erro-app.model';
import { CodigoErroConstante } from "../../shared/constants/codigo-erro.constant";
import { TipoAutenticacaoEnum } from "../../shared/enums/tipo-autenticacao.enum";

export class ConsultarTramiteExternoAction extends Action { constructor(public chaveAcesso: any, public idAssinante: any) { super(); } }
export class DownloadArquivoAssinadoAction extends Action {constructor(public chaveAcesso: any, public idAssinante: any, public idAnexo: number){ super()}}
export class DownloadArquivoOriginalSemMarcaDaguaAction extends Action {constructor(public chaveAcesso: any, public idAssinante: any, public idAnexo: number){ super()}}
export class RejeitarAssinaturaTramiteAction extends Action { constructor(public chaveAcesso: any, public idAssinante: any, public justificativa: string){super()}}
export class RegistrarAssinaturaDigitalOnlineAction extends Action { constructor(public chaveAcesso: any, public idAssinante: any, public idTramite: number) { super(); } }
export class RegistrarAssinaturaGovBrAction extends Action { constructor(public chaveAcesso: any, public idTramite: number, public idAssinante: number, public code: string , public assinatura: Assinatura) { super(); } }


@Injectable()
export class VisualizadorStore extends Store
{

    constructor(private service: VisualizadorService, private svc: Services, private router: Router)
    {
        super();
    }

    @action()
    rejeitarAssinaturaTramiteExterno(state: AppState, act: RejeitarAssinaturaTramiteAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
        {
            this.svc.logger.debug('[VisualizarStore/ rejeitarAssinaturaTramiteExterno');
            this.service.rejeitarDocumentoTramiteAction(act.chaveAcesso, act.idAssinante, act.justificativa).subscribe(
                (data: DocumentoTramite )=>{
                    return resolve({documentoTramite:data})
                },
                (error: any) =>
                {
                    console.log("--> ", error);
                    this.feedbackEngine(error);
                    this.svc.logger.error('[VisualizadorStore / rejeitarAssinaturaTramiteExterno] Erro ao consultar assinante externo', act, error);
                    return reject(error);
                }
            )
        });
    }

    @action()
    registrarOnline(state: AppState, act: RegistrarAssinaturaDigitalOnlineAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
        {
            this.svc.logger.debug('[VisualizadorStore / registrar] Registrando assinatura digital');
            this.service.registrarAssinaturaDigitalOnlineFase3(act.chaveAcesso, act.idTramite, act.idAssinante).subscribe(
            (data: any ) =>
            {
                return resolve(data);
            },
            (error: any) =>
            {
                this.feedbackEngine(error);
                this.svc.logger.error('[VisualizadorStore / registrar] Erro ao registrar assinatura digital', act.idAssinante, error);
                return reject(error);
            });
        });
    }

    @action()
    registrarGovBr(state: AppState, act: RegistrarAssinaturaGovBrAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
        {
            let parametroAssinatura = this.svc.helperService.clonar(act.assinatura);
            this.svc.logger.debug('[VisualizadorStore / registrarGovBr] Registrando assinatura Gov Br', act.idTramite, parametroAssinatura);

            this.service.registrarAssinaturaGovBr(act.chaveAcesso, act.idTramite, act.idAssinante, act.code, parametroAssinatura).subscribe(
            () =>resolve({tipoAutenticacao:TipoAutenticacaoEnum.GovBR}),
            (error: any) =>
            {
                if (error instanceof ErroApp)
                {
                  if (error.codigoErro != null && error.codigoErro.toLowerCase() == CodigoErroConstante.GOVBR_NIVEL_INVALIDO.toLowerCase())
                  {
                    this.router.navigate(['acesso-gov-br-bronze']);
                    return;
                  }
                  if (error.codigoErro != null && error.codigoErro.toLowerCase() == CodigoErroConstante.SESSAO_GOVBR_EXPIRADA.toLocaleLowerCase())
                  {
                    this.svc.acessoExternoService.realizarLogoutGovBr('sessaoExpirada');
                    return;
                  }
                  this.feedbackEngine(error, "Não foi possível registrar a assinatura gov.br. Tente novamente");
                  return reject(error);
                }
                this.svc.logger.error('[VisualizadorStore / registrarGovBr] Erro ao registrar assinatura Gov Br', parametroAssinatura, error);
                this.feedbackEngine(error, "Não foi possível registrar a assinatura gov.br. Tente novamente");
                return reject(error);
            });
        });
    }

    @action()
    consultarTramiteExterno(state: AppState, act: ConsultarTramiteExternoAction): Promise<AppState>
    {
        return new Promise((resolve, reject)=>{
            this.svc.logger.debug('[VisualizarStore/ consultarTramiteExterno] Consultando Tramite via Externo', act);
            this.service.consultarTramiteExterno(act.chaveAcesso, act.idAssinante).subscribe(
                (data: DocumentoTramite )=>{

                    return resolve({documentoTramite:data});
                },
                (error: any)=>
                {
                    this.feedbackEngine(error);
                    this.svc.logger.error('[VisualizadorStore / consultarTramiteExterno] Erro ao consultar tramite externo', act, error);
                    return reject(error);
                }
            );
        });
    }

    @action()
    downloadArquivoAssinado(state: AppState, act: DownloadArquivoAssinadoAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
            {
                this.svc.logger.debug('[VisualizadorStore / downloadArquivoAssinado] Download de arquivo assinado.', act);
                this.service.downloadArquivoAssinado(act.chaveAcesso, act.idAssinante, act.idAnexo).subscribe(
                (data: Blob) =>
                {
                    saveAs(data, 'arquivo-assinado.pdf');
                },
                (error: any) =>
                {
                    this.feedbackEngine(error);
                    this.svc.logger.error('[VisualizadorStore / downloadArquivoAssinado] Erro ao realizar o download', act, error);
                    return reject(error);
                }
            );
        });
    }

    @action()
    downloadArquivoOriginalSemMarcaDagua(state: AppState, act: DownloadArquivoOriginalSemMarcaDaguaAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
            {
                this.svc.logger.debug('[VisualizadorStore / downloadArquivoOriginalSemMarcaDagua] Download de arquivo original.', act);
                this.service.downloadArquivoOriginalSemMarcaDagua(act.chaveAcesso, act.idAssinante, act.idAnexo).subscribe(
                (data: Blob) =>
                {
                    saveAs(data, 'arquivo-original.pdf');
                },
                (error: any) =>
                {
                    this.feedbackEngine(error);
                    this.svc.logger.error('[VisualizadorStore / downloadArquivoOriginalSemMarcaDagua] Erro ao realizar o download', act, error);
                    return reject(error);
                }
            );
        });
    }

    private feedbackEngine(error: any, titulo?: any)
    {
        this.svc.logger.error(`[ERRO] [VisualizadorStore / feedbackEngine]`, error);
        if (error instanceof HttpErrorResponse)
        {
            this.router.navigate(['sessaoExpirada']);
            if (error.hasOwnProperty('error') &&
                error.error.hasOwnProperty('mensagem') &&
                error.error.mensagem.toUpperCase().indexOf("ACESSO NEGADO") > -1) {
                return;
            }
            let msg = (titulo != null) ? `${titulo} ${error.message}` : error.message;
            this.svc.bnAlertService.alertaErro(`Erro ${error.status}`, msg);
        }
        else if (error instanceof ErroApp)
        {
          let msg = (titulo != null) ? `${error.cabecalho} ${titulo}` : error.cabecalho;
          this.svc.bnAlertService.alertaErro('Erro', msg, error.listaComentarios);
        }
        else {
          let msg = (titulo != null) ? `${titulo} ${error}` : error;
          this.svc.bnAlertService.alertaErro(`Erro`, msg);
        }
    }
}
